module.exports = __webpack_public_path__ + "img/broom.d466ddaa.svg";